import { keys } from 'lodash';
import { PRODUCTS as productConstants } from './build';

export const BASELINE = 'BASELINE';
export const BUILD_NUMBER = 'BUILD_JOB_NUMBER';
export const CREATED_AT = 'CREATED_AT';
export const COMMITMSG = 'COMMITMSG';
export const DELEGATEJOB = 'DELEGATEJOB';
export const DETAILS = 'DETAILS';
export const DIFFTYPES = 'DIFFTYPES';
export const DISPATCHEDBY = 'DISPATCHEDBY';
export const DISPATCHER = 'DISPATCHER';
export const DISPATCHERTYPE = 'DISPATCHERTYPE';
export const ERROR_CODE = 'ERROR_CODE';
export const EXAMINE_VERSION = 'EXAMINE_VERSION';
export const EXE_VERSION = 'EXE_VERSION';
export const IEF_ENGINE_VERSION = 'IEF_ENGINE_VERSION';
export const IMAGEFILE = 'IMAGEFILE';
export const INSTALL_SUCCESS = 'INSTALL_SUCCESS';
export const NODE = 'NODE';
export const PREV_IEF_VERSION = 'PREVIOUS_IEF_VERSION';
export const PREV_PROCESS_VERSION = 'PREVIOUS_PROCESS_VERSION';
export const PROCESS_VERSION = 'PROCESS_VERSION';
export const PRODUCT_NAME = 'PRODUCT_NAME';
export const SCENARIO = 'SCENARIO';
export const SCENARIOCOUNT = 'SCENARIOCOUNT';
export const SECOND_WYUPDATE_URL = 'SECOND_WYUPDATE_URL';
export const TOPICBRANCH = 'TOPICBRANCH';
export const WYUPDATE_URL = 'WYUPDATE_URL';
export const AGENT_VM_LABEL = 'AGENT_VM_LABEL';
export const AGENT_VM_IP = 'AGENT_VM_IP';
export const AGENT_PLATFORM_IDENTIFIER = 'AGENT_PLATFORM_IDENTIFIER';

export const JENKINS_ARTIFACT_DLL_NUMBER = 'JENKINS_ENV:ARTIFACT_DLL_NUMBER';
export const JENKINS_ARTIFACT_DLL_PATH = 'JENKINS_ENV:ARTIFACT_DLL_PATH';
export const JENKINS_ARTIFACT_NUGET_PKG_NUMBER =
  'JENKINS_ENV:ARTIFACT_NUGET_PACKAGE_NUMBER';
export const JENKINS_ARTIFACT_NUGET_PKG_VERSION =
  'JENKINS_ENV:ARTIFACT_NUGET_PACKAGE_VERSION';
export const JENKINS_DO_NOT_USE_AS_BASELINE = 'JENKINS_ENV:DO_NOT_USE_AS_BASELINE';
export const JENKINS_AXE_BUILD_PARAMETER = 'JENKINS_ENV:AXE_BUILD_PARAMETER';
export const JENKINS_AXE_BUILD_TYPE = 'JENKINS_ENV:AXE_BUILD_TYPE';
export const JENKINS_AXP_BUILD_PARAMETER = 'JENKINS_ENV:AXP_BUILD_PARAMETER';
export const JENKINS_AXP_BUILD_TYPE = 'JENKINS_ENV:AXP_BUILD_TYPE';
export const JENKINS_BASELINE = 'JENKINS_ENV:BASELINE';
export const JENKINS_BOT_SERVER_NAME = 'JENKINS_ENV:BOT_SERVER_NAME';
export const JENKINS_BUILD_LABEL = 'JENKINS_ENV:BUILD_LABEL';
export const JENKINS_BUILD_NUMBER = 'JENKINS_ENV:BUILD_NUMBER';
export const JENKINS_BUILD_TAG = 'JENKINS_ENV:BUILD_TAG';
export const JENKINS_BUILD_URL = 'JENKINS_ENV:BUILD_URL';
export const JENKINS_CASE_FILES = 'JENKINS_ENV:CASE_FILES';
export const JENKINS_CASE_TYPE = 'JENKINS_ENV:CASE_TYPE';
export const JENKINS_CATEGORIES = 'JENKINS_ENV:CATEGORIES';
export const JENKINS_DIFF_OUTPUT_PATH = 'JENKINS_ENV:DIFF_OUTPUT_PATH';
export const JENKINS_DISPATCHER_JOB_NAME_NUMBER =
  'JENKINS_ENV:DISPATCHER_JOB_NAME_NUMBER';
export const JENKINS_DISPATCHER_SCENARIO_NAME = 'JENKINS_ENV:DISPATCHER_SCENARIO_NAME';
export const JENKINS_EXPORT_TYPES = 'JENKINS_ENV:EXPORT_TYPES';
export const JENKINS_FIRST_WYUPDATE_VERSION = 'JENKINS_ENV:FIRST_WYUPDATE_VERSION';
export const JENKINS_IEF_VER = 'JENKINS_ENV:IEF_VER';
export const JENKINS_IMAGE_FILENAME = 'JENKINS_ENV:IMAGE_FILENAME';
export const JENKINS_IMAGE_PATH = 'JENKINS_ENV:IMAGE_PATH';
export const JENKINS_INSTALL_VERSION = 'JENKINS_ENV:INSTALL_VERSION';
export const JENKINS_INSTALLER_LIST = 'JENKINS_ENV:INSTALLER_LIST';
export const JENKINS_JOB_BASE_NAME = 'JENKINS_ENV:JOB_BASE_NAME';
export const JENKINS_JOB_NAME = 'JENKINS_ENV:JOB_NAME';
export const JENKINS_JOB_URL = 'JENKINS_ENV:JOB_URL';
export const JENKINS_LABEL = 'JENKINS_ENV:LABEL';
export const JENKINS_LOCALE = 'JENKINS_ENV:LOCALE';
export const JENKINS_NUMBER = 'JENKINS_ENV:NUMBER';
export const JENKINS_OUTPUT_PATH = 'JENKINS_ENV:OUTPUT_PATH';
export const JENKINS_OVERINSTALL_VERSION = 'JENKINS_ENV:OVERINSTALL_VERSION';
export const JENKINS_OVERINSTALLER_LIST = 'JENKINS_ENV:OVERINSTALLER_LIST';
export const JENKINS_POST_UPDATE_LOCATIONS = 'JENKINS_ENV:POST_UPDATE_LOCATIONS';
export const JENKINS_POST_UPDATE_VERSION = 'JENKINS_ENV:POST_UPDATE_VERSION';
export const JENKINS_PRE_UPDATE_VERSION = 'JENKINS_ENV:PRE_UPDATE_VERSION';
export const JENKINS_PRE_UPDATE_LOCATIONS = 'JENKINS_ENV:PRE_UPDATE_LOCATIONS';
export const JENKINS_SECOND_WYUPDATE_VERSION = 'JENKINS_ENV:SECOND_WYUPDATE_VERSION';
export const JENKINS_TESTDLL_NAMES = 'JENKINS_ENV:TESTDLL_NAMES';
export const JENKINS_TOPIC_BRANCH = 'JENKINS_ENV:TOPIC_BRANCH';
export const JENKINS_TRIGGER_BY = 'JENKINS_ENV:TRIGGERED_BY';
export const JENKINS_USE_S3 = 'JENKINS_ENV:USE_S3';

export const BIGSHINYHITS = 'BigShinyHits';
export const REALDATA4 = 'RealData4';

export const JENKINS_ENV_PREFIX = 'JENKINS_ENV:';

export const VERSION_BY_PRODUCT = (product) =>
  product === productConstants.AXIOM ? PROCESS_VERSION : IEF_ENGINE_VERSION;
export const PREV_VERSION_BY_PRODUCT = (product) =>
  product === productConstants.AXIOM ? PREV_PROCESS_VERSION : PREV_IEF_VERSION;

export const PRODUCT_TO_VERSION_PARAM_MAP = {
  [productConstants.IEF_ENGINE]: IEF_ENGINE_VERSION,
  [productConstants.PROCESS]: PROCESS_VERSION,
  [productConstants.EXAMINE]: EXAMINE_VERSION,
};

export const getJobProductVersions = (jobParams) => {
  if (!jobParams) {
    return {};
  }
  const foundVersions = Object.values(PRODUCT_TO_VERSION_PARAM_MAP).reduce((acc, paramName) => {
    if (jobParams[paramName]) {
      acc[paramName] = jobParams[paramName];
    }
    return acc;
  }, {});

  return foundVersions;
};


/**
 * The whitelist for JENKINS params to be displayed
 * as Scenario info on Regression pages
 */
export const regressionPageDisplayList =
  [
    JENKINS_BASELINE,
    JENKINS_DISPATCHER_JOB_NAME_NUMBER,
    JENKINS_FIRST_WYUPDATE_VERSION,
    JENKINS_INSTALL_VERSION,
    JENKINS_JOB_NAME,
    JENKINS_LOCALE,
    JENKINS_NUMBER,
    JENKINS_OVERINSTALL_VERSION,
    JENKINS_PRE_UPDATE_VERSION,
    JENKINS_POST_UPDATE_VERSION,
    JENKINS_SECOND_WYUPDATE_VERSION,
    JENKINS_ARTIFACT_DLL_PATH,
    JENKINS_ARTIFACT_NUGET_PKG_NUMBER,
    JENKINS_ARTIFACT_NUGET_PKG_VERSION,
  ];

/**
 * The whitelist for JENKINS params to be displayed
 * as Job info on Metrics pages
 */
export const metricsPageDisplayList = [
  JENKINS_DISPATCHER_JOB_NAME_NUMBER,
  JENKINS_EXPORT_TYPES,
  JENKINS_TOPIC_BRANCH
];

export const metricsPageParamsDisplayList = [
  JENKINS_ARTIFACT_NUGET_PKG_VERSION
];

export const paramsOrder = {
  'INSTALL_VERSION': 0,
  'OVERINSTALL_VERSION': 1,
  'PRE_UPDATE_VERSION': 2,
  'EXE_VERSION': 3,
  'POST_UPDATE_VERSION': 4
};

export const DISPATCHER_INFO_PARAM_NAMES = [
  BUILD_NUMBER,
  CREATED_AT,
  DELEGATEJOB,
  DETAILS,
  DIFFTYPES,
  DISPATCHEDBY,
  DISPATCHER,
  DISPATCHERTYPE,
  EXAMINE_VERSION,
  EXE_VERSION,
  IEF_ENGINE_VERSION,
  JENKINS_ARTIFACT_DLL_NUMBER,
  JENKINS_ARTIFACT_DLL_PATH,
  JENKINS_ARTIFACT_NUGET_PKG_NUMBER,
  JENKINS_ARTIFACT_NUGET_PKG_VERSION,
  JENKINS_AXE_BUILD_PARAMETER,
  JENKINS_AXE_BUILD_TYPE,
  JENKINS_AXP_BUILD_PARAMETER,
  JENKINS_AXP_BUILD_TYPE,
  JENKINS_BUILD_LABEL,
  JENKINS_CATEGORIES,
  JENKINS_EXPORT_TYPES,
  JENKINS_FIRST_WYUPDATE_VERSION,
  JENKINS_INSTALL_VERSION,
  JENKINS_INSTALLER_LIST,
  JENKINS_OVERINSTALL_VERSION,
  JENKINS_OVERINSTALLER_LIST,
  JENKINS_POST_UPDATE_LOCATIONS,
  JENKINS_PRE_UPDATE_LOCATIONS,
  JENKINS_SECOND_WYUPDATE_VERSION,
  JENKINS_TESTDLL_NAMES,
  JENKINS_USE_S3,
  NODE,
  PROCESS_VERSION,
  SCENARIOCOUNT,
  SECOND_WYUPDATE_URL,
  TOPICBRANCH,
  WYUPDATE_URL,
  AGENT_VM_LABEL,
  AGENT_VM_IP,
  AGENT_PLATFORM_IDENTIFIER,
];

/**
 * Returns new object containing the given params after applying
 * available cleansing options
 * @param params {obj} - the params to clean
 * @param jenkinsParamsToKeep {string[]} - list of strings representing JENKINS params
 * which are intended to be kept
 * @param removeJenkinsPrefix {bool} - whether or not JENKINS_ENV prefix should be removed
 * Default is true.
 * @param categorizedResult {bool} - whether or not to separate the result by jenkins.
 * Default is false.
 */
export const cleanParams = (
  params,
  jenkinsParamsToKeep = [],
  removeJenkinsPrefix = true,
  categorizedResult = false
) => {
  if (!params) {
    return undefined;
  }

  const reduced = keys(params).reduce((acc, sourceKey) => {
    if (sourceKey.startsWith(JENKINS_ENV_PREFIX)) {
      // only keep if in whitelist
      if (jenkinsParamsToKeep.filter(p => p === sourceKey).length === 0) {
        return acc;
      }

      const targetKey = removeJenkinsPrefix ?
        sourceKey.slice(JENKINS_ENV_PREFIX.length) :
        sourceKey;
      acc['jenkins'][targetKey] = params[sourceKey];
    }
    else {
      acc['nonJenkins'][sourceKey] = params[sourceKey];
    }
    return acc;
  }, { jenkins: {}, nonJenkins:{}});

  // * Jenkins params override nonJenkins if keys are shared and categorized
  const result = categorizedResult ?
    reduced :
    { ...reduced['nonJenkins'], ...reduced['jenkins'] };
  return result;
};


// WEBPACK FOOTER //
// src/helpers/params.js